import React, { useRef } from 'react';
import { useForm } from 'react-hook-form';

interface VerifyFormProps {
  isLoading: boolean;
  verifyOtp: (code: string) => void;
  phone: string;
}

interface VerifyFormData {
  code: string;
}

const VerifyForm: React.FC<VerifyFormProps> = ({ isLoading, verifyOtp }) => {
  const isLoadingRef = useRef(false);
  const verifyForm = useForm<VerifyFormData>({
    defaultValues: {
      code: '',
    }
  });

  const handleSubmit = (data: VerifyFormData) => {
    if (isLoadingRef.current) return;
    
    isLoadingRef.current = true;
    verifyOtp(data.code);
    
    // 성공/실패 관계없이 일정 시간 후 잠금 해제
    setTimeout(() => {
      isLoadingRef.current = false;
    }, 3000);
  };

  return (
    <form onSubmit={verifyForm.handleSubmit(handleSubmit)} className="w-full space-y-4">
      <div>
        <label>인증번호</label>
        <input
          type="text"
          inputMode='numeric'
          id="code"
          autoFocus
          {...verifyForm.register('code', { 
            required: '인증번호를 입력해주세요',
            pattern: {
              value: /^\d{6}$/,
              message: '6자리 숫자를 입력해주세요'
            }
          })}
          placeholder="123456"
          className="w-full"
        />
        {verifyForm.formState.errors.code && (
          <p className="mt-1 ml-2 text-sm text-red-500">{verifyForm.formState.errors.code.message}</p>
        )}
      </div>
      <button
        type="submit"
        disabled={isLoading}
        className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-xl font-bold text-white bg-blue-500 cursor-pointer"
      >
        {isLoading ? '처리중...' : '인증하기'}
      </button>
    </form>
  );
};

export default VerifyForm; 